<template>
  <div class="visits-overview-page" data-cy="visits-overview-page">
    <AccessHandler
      :requiredRoleGroups="roleGroups"
      @accessChanged="(a: boolean) => (hasAccess = a)"
    />
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <VisitsOverviewView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "@/views/MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import {
  RCorRcSupportStaffGroup,
  type RoleGroup,
} from "@/shared/access/RoleGroups";
import { ref } from "vue";
import VisitsOverviewView from "./VisitsOverviewView.vue";

const roleGroups = [RCorRcSupportStaffGroup] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.visits-overview-page {
  .master-page {
    height: 100vh;
  }
}
</style>
